const state = {
  phoneNumber: undefined,
};

const mutations = {
  setPhoneNumber(state, phoneNumber) {
    state.phoneNumber = phoneNumber;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
